import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled, { css } from '@xstyled/styled-components';
import { Spin } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledLoading = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  ", "\n"])), function (props) {
  return props.$loading ? css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          .overlay {\n            width: inherit;\n            height: inherit;\n            position: absolute;\n            bottom: 0;\n            background: ", ";\n            opacity: 0.5;\n            z-index: 2;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n          }\n        "])), props.theme.color.backgroundOverlay) : '';
});
export var OverlayComponent = function OverlayComponent(_ref) {
  var showingLoading = _ref.showingLoading,
      children = _ref.children;
  return /*#__PURE__*/_jsxs(StyledLoading, {
    $loading: showingLoading,
    children: [children, showingLoading && /*#__PURE__*/_jsx("div", {
      className: "overlay",
      children: /*#__PURE__*/_jsx(Spin, {
        size: "large"
      })
    })]
  });
};